import { render, staticRenderFns } from "./LabelReferenceTable.vue?vue&type=template&id=60eb59f9&scoped=true"
import script from "./LabelReferenceTable.vue?vue&type=script&lang=js"
export * from "./LabelReferenceTable.vue?vue&type=script&lang=js"
import style0 from "./LabelReferenceTable.vue?vue&type=style&index=0&id=60eb59f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb59f9",
  null
  
)

export default component.exports